import { NavLink } from 'react-router-dom';
import options from './options';
import { HashLink as Link } from 'react-router-hash-link';
import { withNamespaces } from 'react-i18next';
import { t } from 'i18next';

const Header: React.FC = () => {
  options();

  return (
    <header className="header">
      <div className="container">
        <nav className="header__nav">
          <ul className="header__menu">
            <li>
              <NavLink to="/">{t('nav_main')}</NavLink>
            </li>
            <li>
              <Link to="/#about">{t('nav_about')}</Link>
            </li>
            <li>
              <NavLink to="/projects">{t('nav_projects')}</NavLink>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};
export default withNamespaces()(Header);
